import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { MdOutlineDashboard } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { GoGear } from "react-icons/go";
import { TfiVideoClapper } from "react-icons/tfi";
import { MdOutlineHistory } from "react-icons/md";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import decoration from "../../assets/images/decoration.png";
import decorationPiece from "../../assets/images/strip-decoration.png";
import logo from "../../assets/images/logo2.png";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Sidebar = ( ) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeTab, setActiveTab] = useState("dashboard");
 const navigate = useNavigate();
   const location = useLocation();
       const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    useEffect(() => {
    const pathParts = location.pathname.split("/");
    const active = pathParts[2]; 
    if (active) setActiveTab(active);
  }, [location]);
  const navItems = [
    {
      to: "dashboard",
      icon: <MdOutlineDashboard size={20} />,
      label: "c_list_1",
    },
    {
      to: "profile",
      icon: <CgProfile size={20} />,
      label: "t_menu_text1",
    },
    {
      to: "projects",
      icon: <TfiVideoClapper size={20} />,
      label: "t_menu_text2",
    },
    {
      to: "history",
      icon: <MdOutlineHistory size={20} />,
      label: "t_menu_text4",
    },
    {
      to: "earnings",
      icon: <FaMoneyBillTrendUp size={20} />,
      label: "t_menu_text3",
    },
    {
      to: "settings",
      icon: <GoGear size={20} />,
      label: "t_menu_text5",
    },
  ];
 const handleNavClick = (path) => {
    setActiveTab(path);
    navigate(`/talent/${path}`);
    setShowSidebar(false); // close after clicking
  };
   const handleToggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };
  // Sidebar content as a function to reuse in both offcanvas and desktop
  const SidebarContent = () => (
    <div
      className="inter-font "
      style={{
        // background: "#411318",
        width: "100%",
        color: "white",
        height: "100%",
        paddingLeft: isRTL ? "0" : "1.5rem",
        paddingRight: isRTL ? "1.5rem" : "0",
      }}
    >
      {/* Decoration strips (only show on desktop) */}

      <div className="inter-font d-flex" style={{ height: "100%" }}>
        <div className="inter-font py-4" style={{maxWidth:"272px"}}>
          {/* Logo */}
          <Link to={"/talent/dashboard"} className="inter-font text-center mb-5">
            <img src={logo} className="inter-font w-50" alt="Company Logo" />
          </Link>

          {/* Navigation */}
          <nav className="flex-grow-1 pt-5" style={{maxWidth:"200px"}}>
            <ul className="list-unstyled">
              {navItems.map((item) => (
                <li key={item.to} className="inter-font mb-4">
                  <div
                    className={ `inter-font text-black d-flex align-items-center position-relative cursor-pointer ${
                      activeTab === item.to ? "active-nav-item" : ""
                    }`}
                    onClick={() => handleNavClick(item.to)}
                    style={{ padding: "8px 0" }}
                  >
                    <span
                      className="inter-font icon-wrapper "
                      style={{ width: "24px", color: "black" }}
                    >
                      {item.icon}
                    </span>
                    <span className={`inter-font  inter-font fw-light ${isRTL ? 'me-3' : 'ms-3'}`} >
                      {t(item.label)}
                    </span>

                    {activeTab === item.to && (
                      <div
                        style={{
                          width: "30px",
                          height: "2px",
                          backgroundColor: "rgba(231, 142, 123, 1)",
                          position: "absolute",
                          bottom: "0px",
                          left: isRTL ? "0": "40px",
                          right: isRTL ? "40px": "0",
                        }}
                      />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        {/* <div
          className="inter-font d-none d-md-block"
          style={
            {
              // width: "20%",
              // position: "absolute",
              // top: "0px",
              // left: "13%",
              // marginLeft: "5px",
            }
          }
        >
          <img
            // key={i}
            src={decorationPiece}
            alt="Decoration"
            style={{ width: "30px", height: "100%" }}
          /> */}
          {/* {[...Array(1)].map((_, i) => (
            <img
              key={i}
              src={decorationPiece}
              alt="Decoration"
              style={{ width: "35px" }}
            />
          ))} */}
        {/* </div> */}
        {/* <div  className=""> */}
       <div className={`${isRTL ? 'right-strip-talent' : 'left-strip-talent'} d-none d-md-block`} style={{ paddingTop: 0 }}>
  {[...Array(25)].map((_, i) => (
    <img
      key={i}
      src={decoration}
      alt="Decoration"
      className="strip-icon"
    />
  ))}
</div>
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile Toggle Button */}
 <button
  className="inter-font d-lg-none"
  style={{
    position: "fixed",
    top: "15px",
    left: "15px",
    background: "#411318",
    color: "white",
    fontSize: "22px",
    fontWeight: "bold",
    border: "none",
    outline: "none",
    zIndex: 1100,
    padding: "4px 8px",
    borderRadius: "6px",
    cursor: "pointer",
  }}
  onClick={handleToggleSidebar}
>
  {showSidebar ? "✕" : "☰"}
</button>

      {/* Desktop Sidebar */}
      <div className="inter-font d-none d-lg-block">
        <SidebarContent />
      </div>

      {/* Mobile Offcanvas Sidebar */}
      <Offcanvas
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        placement="start"
        backdrop={true}
          style={{
    zIndex: 90000,
  }}
      >
        <Offcanvas.Body className="inter-font p-0">
          <SidebarContent />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
